const auth = {
	isAuth: false,
	role: '',
	name: '',
	token: ''
};

export default auth;
